import BVD from "../../assets/company-logos/Bureau_van_Dijk.png";
import Equifax from "../../assets/company-logos/Equifax.png";
import Acuris from "../../assets/company-logos/Acuris.png";
import Experian from "../../assets/company-logos/Experian.png";
import OpenCorporates from "../../assets/company-logos/OpenCorporates.png";
import CreditorWatch from "../../assets/company-logos/creditorwatch.png";
import CreditSafe from "../../assets/company-logos/Creditsafe.png";
import NominoData from "../../assets/company-logos/Nominodata.png";
import AustralianBusinessRegister from "../../assets/company-logos/AustralianBusinessRegister.png";
import SayariLabs from "../../assets/company-logos/SayariLabs.png";
import BusinessFirmographics from "../../assets/resource-images/business_firmographics_for_us_kyb.png";
import BusinessRegistration from "../../assets/resource-images/business_registration_and_linked_company_details_for_global_kyb.png";
import ConsumerWatchlist from "../../assets/resource-images/consumer_watchlist_fraud_screening.png";

const data = {
  usecaseInfo: {
    name: "KYB Workflow Automation",
    description:
      "A single platform for seamless onboarding and verification of businesses globally.",
  },
  recipesInfo: {
    title: "Onboard businesses in seconds",
    description:
      "Access API-ready solutions for business registry verification, director and ultimate benefit ownership identification, global anti-money laundering (AML) and watchlist screening, politically exposed persons (PEP) screening, negative news screening, and digital presence assessment, among many others.",
  },
  recipes: [
    {
      type: "Business Data",
      title: "Business Registration and Ownership Information",
      description:
        "Check for a business' registration and linked companies such as parents, UBOs, subsidiaries and more.",
      url: "/app/data-catalog/recipes?all=false&data_source=&direction=&page=1&search=registration&sort=&tags[]=KYB%20Workflow%20Automation",
    },
    {
      type: "Business Data",
      title: "Business Firmographics",
      description:
        "Identify industry codes, annual sales revenue, number of employees, business start year, and contact details.",
      url: "/app/recipe/2/business-firmographics-for-us-kyb-onboarding-and-marketing",
    },
    {
      type: "Business Data",
      title: "Domain checks for Business Digital Presence",
      description:
        "Validate and identify a business and its pertinent information from a supplied business domain.",
      url: "/app/recipe/43/business-firmographics-from-domain-for-kyb-onboarding-marketing",
    },
    {
      type: "Business Data",
      title: "Judgement Counts",
      description: "Assess the financial health of a business by examining raw judgments data.",
      url: "/app/recipe/3/business-judgment-counts-for-us-kyb-and-onboarding",
    },
    {
      type: "Business Data",
      title: "Watchlist and Fraud screening",
      description:
        "Check for business presence on any relevant watchlists such as sanctions, PEP, adverse media, and more.",
      url: "/app/recipe/56/business-watchlist-and-fraud-screening",
    },
    {
      type: "Other Data",
      title: "...And Many More",
      description: "Access all of our KYB api-ready recipes now.",
      ctaText: "Access Recipe Catalog",
      url: "/app/data-catalog/recipes?page=1&tags[]=KYB%20Workflow%20Automation",
    },
  ],

  dataPartners: {
    title: "Sample Data Providers",
    description: "Access to hundreds of data partners worldwide",
    logos: [
      {
        name: "AustralianBusinessRegister",
        img: AustralianBusinessRegister,
      },
      {
        name: "Equifax",
        img: Equifax,
      },
      {
        name: "Bureau van Dijk (BvD)",
        img: BVD,
      },
      {
        name: "Acuris",
        img: Acuris,
      },
      {
        name: "CreditorWatch",
        img: CreditorWatch,
      },
      {
        name: "Experian",
        img: Experian,
      },
      {
        name: "Sayari Labs",
        img: SayariLabs,
      },
      {
        name: "OpenCorporates",
        img: OpenCorporates,
      },
      {
        name: "CreditSafe",
        img: CreditSafe,
      },
      {
        name: "Nomino Data",
        img: NominoData,
      },
    ],
  },
  resourcesInfo: {
    title: "Resources",
    description: "The latest news, technologies, and resources from our team.",
  },
  resources: [
    {
      title: "5 Checks For Flagging Fraud Risk",
      url: "https://demyst.com/blog/5-checks-for-flagging-fraud-risk",
      featured_image: "https://cdn.buttercms.com/DRlPxD3RTbyFaP0LERTt",
      date: "2022-04-20",
      description:
        "Paypal’s recent discovery of 4.5 million illegitimate accounts on its platform should be a warning heeded by all: even the largest, most sophisticated payment processors can fall victim to bad actors. An effective ID verification process considers 5 data points: ",
      more: "",
    },
    {
      title: "Digital Footprints for ID Verification",
      url: "https://demyst.com/blog/digital-footprints-for-id-verification",
      featured_image: "https://cdn.buttercms.com/bez6PhOGT5KMUdsTQKIC",
      date: "2022-02-03",
      description:
        "Demyst spoke with Gergő Varga, product evangelist at Seon, to discuss how external data can be used to go beyond basic anti-fraud checks. Varga explained how an individual’s online record of activity can be used like a digital footprint, which offers a more comprehensive approach to confirming identities.",
      more: "",
    },
    {
      title: "Global IDV Workflows Demand Multi Source Solutions",
      url: "https://demyst.com/blog/digital-id-verification-a-multi-source-solution",
      featured_image: "https://cdn.buttercms.com/i3HoaJZxSsQ91PGkEonW",
      date: "2022-01-28",
      description:
        "Across the world, financial institutions (FIs) are struggling to optimize customer onboarding processes while maintaining sufficient controls for risk, fraud, and identity verification (IDV). This pressure is exacerbated by incomplete data products, data markets that vary in maturity (certain markets have near 100% coverage in identity while others are much more nascent), and a strong desire for innovation.",
      more: "",
    },
    {
      title: "Consumer Watchlist and Fraud Screening",
      url: "https://www.youtube.com/watch?v=SI7nO_VT4FY",
      featured_image: ConsumerWatchlist.src,
      date: "2022-03-18",
      description:
        "A regulated financial services firm has obligations to conduct know-your-customer (KYC) checks on consumers that it wishes to do business with. This involves confirming that a customer is who they say they are in order to reduce fraud and other bad-actor risks. You can use this recipe to establish an automated process that can flag for relevant risks in real-time, reducing manual reviews to only those that require it and providing a more seamless customer experience.",
      more: "",
    },
    {
      title: "Business Firmographics for US KYB",
      url: "https://youtu.be/tAOqrNejBgY",
      featured_image: BusinessFirmographics.src,
      date: "2022-05-5",
      description:
        "When using this recipe, provide the registered name of the business and its address to retrieve available business firmographics (such as SIC and NAICS codes, website, phone number, and business age) along with financial performance metrics (such as number of employees and sales).",
      more: "",
    },
    {
      title: "Business Registration and Linked Company Details for Global KYB",
      url: "https://www.youtube.com/watch?v=VklaR6XfB2w",
      featured_image: BusinessRegistration.src,
      date: "2022-06-2",
      description:
        "Use this recipe as part of a know-your-business (KYB) workflow outside the US to gather key information all in a centralized place, ready for an automated approval workflow or a simplified review process. When using this recipe, input a business' name and country, and it will return a business' registration for the most likely matched business based off the inputs, and also revert shareholder, parent company, subsidiary and ultimate beneficial owner details if they are available.",
      more: "",
    },
  ],
};

export default data;
